/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_DrizzleInputs */

const en_ui_weather_drizzle = /** @type {(inputs: Ui_Weather_DrizzleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drizzle`)
};

const de_ui_weather_drizzle = /** @type {(inputs: Ui_Weather_DrizzleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieselregen`)
};

/**
* | output |
* | --- |
* | "Drizzle" |
*
* @param {Ui_Weather_DrizzleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_drizzle = /** @type {((inputs?: Ui_Weather_DrizzleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_DrizzleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_drizzle(inputs)
	return de_ui_weather_drizzle(inputs)
});